import React from "react";

export default function Nav({ map, layers, setLayers }) {
  const [infoContent, setInfoContent] = React.useState("");
  React.useEffect(() => {
    for (const l in layers) {
      if (layers[l]?.type?.includes("filter") && layers[l]?.visible) {
        handleInfoContent(layers[l]);
        break;
      }
    }
  }, [map]);

  function handleInfoContent(layer) {
  
    if (layer.marker === "layerO") {
      setInfoContent(
        <div>
          <div>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 19.8 19.8"
              enableBackground="new 0 0 19.8 19.8"
            >
              <g>
                <path
                  fill={layer.color}
                  d="M17.3,19.2c-1.8,0-3.5,0-5.3,0c0-1.9,0-3.8,0-5.7c0-1.2-0.9-2.2-2-2.2c-1.1,0-2,0.9-2,2.2c0,1.2,0,2.3,0,3.5
c0,0.7,0,1.4,0,2.2c-1.8,0-3.6,0-5.4,0c0-2.5,0-5,0-7.5c0-0.3,0.1-0.5,0.3-0.7C4.5,9.2,6.2,7.5,8,5.7c0.7-0.7,1.3-1.4,2-2.1
c0.1,0.1,0.2,0.1,0.2,0.2c2.3,2.4,4.6,4.8,7,7.3c0.1,0.1,0.2,0.3,0.2,0.5c0,2.4,0,4.9,0,7.3C17.3,19,17.3,19.1,17.3,19.2z"
                />
                <path
                  fill={layer.color}
                  d="M19.5,10.2c0,0.1,0,0.2,0,0.3c-0.2,0.4-0.5,0.8-0.9,1c-0.2,0.1-0.4,0.1-0.6-0.1c-2.2-2.4-4.5-4.7-6.8-7
C10.9,3.9,10.4,3.5,9.9,3c0,0-0.1,0.1-0.2,0.2c-2.6,2.7-5.1,5.3-7.7,8c-0.4,0.4-0.6,0.5-1,0c-0.2-0.2-0.3-0.4-0.5-0.6
c0-0.1-0.1-0.1-0.1-0.1c0-0.1,0-0.2,0-0.3c0.1-0.1,0.2-0.1,0.2-0.2C2.5,8,4.4,6,6.4,4c1.1-1.1,2.2-2.2,3.3-3.3c0.1,0,0.3,0,0.4,0
c0.2,0.2,0.4,0.3,0.6,0.5c1.4,1.5,2.9,3,4.3,4.5C16.6,7.2,18.1,8.7,19.5,10.2z"
                />
              </g>
            </svg>
            <span>- Office</span>
          </div>
        </div>
      );
    } else if (layer.marker === "layerM") {
      setInfoContent(
        <div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 12 15.7"
            >
              <path
                fill={layer.color}
                d="M7.3,9.6C8,9.4,8.7,9,9.3,8.4c0.7-0.8,1.3-1.9,1.3-3.2
      S10,2.9,9.2,2.1S7.3,0.7,6,0.7S3.6,1.3,2.8,2.1S1.5,4,1.5,5.3S2,7.6,2.8,8.4C3.4,9,4,9.3,4.8,9.6c-2.7,0.4-4.3,1.9-4.3,3.5
      c0,0.9,2,1.8,5.4,1.8c3.2,0,5.4-0.9,5.4-1.8C11.4,11.6,9.8,10,7.3,9.6z"
              />
            </svg>
            <span>- Members</span>
          </div>
        </div>
      );
    } else if (layer.marker === "layerRg") {
      setInfoContent(
        <div>
          <div>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 19.8 19.8"
              enableBackground="new 0 0 19.8 19.8"
            >
              <path
                fill={layer.color}
                d="M1.2,15.9c0.2-0.1,0.2-0.4,0.4-0.6c0.4-0.5,1-0.8,1.5-1.1c0.2-0.1,0.3-0.2,0.5-0.2c0.3-0.2,0.5-0.5,0.5-0.9
C4,12,4.4,10.9,5.1,9.9C5.6,9.2,6.2,8.6,6.8,8c0.8-0.8,1.8-1.2,3-1.2c0.5,0,0.9,0,1.4-0.1c0.3-0.1,0.4-0.2,0.5-0.4
c0.1-0.1,0-0.2,0-0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5-0.4-0.9-0.7-1.3-1.2C9.4,3.9,9.2,3.4,9.1,2.8c0-0.5,0-1,0-1.6
C9.2,1,9.3,0.9,9.6,1c0.4,0.2,0.8,0.4,1.1,0.6C10.9,1.8,11,2,11.1,2.1c0.4,0.8,0.8,1.6,1.2,2.4c0.1,0.2,0.2,0.5,0.4,0.7
c0.1,0.2,0.3,0.3,0.5,0.1c0,0,0,0,0.1,0c0.4,0,0.4-0.3,0.4-0.6c0-0.3,0.1-0.6,0.2-0.8c0.2-0.4,0.4-0.9,0.5-1.3
c0-0.1,0.1-0.3,0.2-0.4c0.4-0.4,0.6-0.9,0.7-1.5c0-0.1,0-0.3,0.2-0.3c0.2,0,0.2,0.2,0.3,0.3c0.1,0.5,0.1,0.9,0,1.4
c-0.2,1.1-0.5,2.2-0.9,3.2c-0.1,0.2-0.1,0.3,0.2,0.4c0.3,0,0.6,0.1,0.8,0.3c0.2,0.1,0.3,0.3,0.6,0.3c0.2,0,0.3,0.2,0.4,0.4
C17,6.9,17.2,7,17.4,7.1c0.6,0.1,0.9,0.5,1.2,0.8c0,0,0,0.1,0,0.1c-0.2,0.1-0.4,0.1-0.6,0.1c-0.8,0.1-1.6,0.4-2.3,0.9
c-0.3,0.2-0.5,0.5-0.9,0.6c-0.5,0.1-0.8,0.5-1.1,0.8c0,0.1-0.1,0.1-0.1,0.2c-0.4,0.4-0.5,0.9-0.3,1.3c0.1,0.5,0,1,0,1.4
c0,0.2,0,0.4,0,0.7c0,0.4,0,0.4,0.4,0.4c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.2-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1
c0.1,0.2,0,0.2-0.2,0.1c-0.2-0.1-0.3-0.1-0.5,0c-0.1,0-0.3,0.1-0.3,0.2c0,0.2-0.1,0.2-0.3,0.1c-0.1,0-0.3-0.2-0.3,0.1
c0,0.1-0.1,0-0.1,0c-0.2-0.2-0.5-0.2-0.8-0.3c-0.2,0-0.3-0.1-0.3-0.3c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2-0.3-0.4-0.5-0.6-0.7
c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.3-0.2-0.2-0.3-0.1c-0.3,0.2-0.4,0.5-0.6,0.7c0,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.2,0.1
c0.3,0,0.5,0,0.8,0c0.3,0,0.6,0.1,0.7,0.4c-0.1,0-0.2,0.1-0.3,0.2c-0.2-0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2
c-0.2-0.2-0.4-0.2-0.7-0.2c-0.3,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.4,0-0.6,0.1c-0.2,0.1-0.2,0.2,0,0.3C8,14.7,8.2,14.9,8.3,15
c0.1,0.1,0,0.3-0.1,0.3c-0.2,0.1-0.4,0.2-0.6,0c-0.2-0.1-0.5-0.2-0.8-0.2c-0.4-0.1-0.9,0-1.3-0.1c-0.2,0-0.4-0.1-0.4-0.3
c0-0.2-0.2-0.2-0.3-0.2c-0.6,0-1.1,0-1.6,0.2c-0.5,0.2-1,0.5-1.3,1c-0.5,0.8-0.1,1.7,0.8,1.9C3,17.9,3.3,17.9,3.7,18
c1.2,0.2,2.4,0.1,3.6,0.3c0.3,0.1,0.7,0.1,0.9,0.4c0.1,0.1,0.2,0.2,0.1,0.2c-0.2,0-0.4,0.2-0.6,0.2c-0.5,0-1,0.2-1.5,0.1
c0,0,0,0,0,0C5.9,19.1,6,19.3,6,19.5c-0.4-0.2-0.9-0.2-1.3-0.3c-0.1,0-0.2-0.1-0.2,0c-0.1,0.1-0.2,0.1-0.3,0c-0.7-0.3-1.3-0.6-1.9-1
c-0.4-0.3-0.8-0.7-0.9-1.2c0-0.1,0-0.1-0.1-0.1C1.2,16.6,1.2,16.2,1.2,15.9z M12.5,14.3c0-0.1,0-0.3,0-0.4c0-0.5-0.3-0.9-0.3-1.5
c0-0.1,0-0.3-0.1-0.3c-0.1,0-0.3,0.1-0.4,0.2c0,0.1,0,0.3,0,0.4c0.2,0.4,0.2,0.8,0.3,1.1c0,0.1,0.1,0.3,0.1,0.4
c0.1,0.2,0.2,0.3,0.3,0.2C12.6,14.6,12.5,14.4,12.5,14.3z"
              />
            </svg>
            <span>- Ranger Groups</span>
          </div>
        </div>
      );
    } else if (layer.marker === "layerCdp") {
      setInfoContent(
        <div>
          <div>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 19.8 19.8"
              enableBackground="new 0 0 19.8 19.8"
            >
              <g>
                <path
                  fill={layer.color}
                  d="M19.4,10c0,5.2-4.3,9.4-9.5,9.4c-5.2,0-9.5-4.2-9.5-9.4c0-5.2,4.2-9.5,9.4-9.5C15.2,0.5,19.4,4.7,19.4,10z M1.7,9.9
c0,4.5,3.7,8.3,8.2,8.3c4.6,0,8.3-3.7,8.3-8.2c0-4.6-3.7-8.3-8.3-8.3C5.4,1.6,1.7,5.4,1.7,9.9z"
                />
                <path
                  fill={layer.color}
                  d="M9.9,3.5c3.5,0,6.4,2.8,6.4,6.4c0,3.5-2.9,6.3-6.3,6.3c-3.5,0-6.4-2.8-6.4-6.3C3.6,6.4,6.4,3.5,9.9,3.5z M15.1,9.8
c0-2.8-2.3-5.1-5.2-5.1C7.1,4.7,4.8,7,4.8,9.9c0,2.8,2.3,5.2,5.2,5.2C12.8,15,15.1,12.7,15.1,9.8z"
                />
                <path
                  fill={layer.color}
                  d="M9.9,13c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1C13,11.7,11.6,13,9.9,13z M8,9.9
c0,1,0.8,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9c0-1-0.9-1.9-1.9-1.9C8.9,8,8,8.9,8,9.9z"
                />
              </g>
            </svg>
            <span>- Projects</span>
          </div>
        </div>
      );
    } else if (layer.link.includes("protected-areas")) {
      setInfoContent(
        <div>
          <div>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19.8 19.8" enableBackground="new 0 0 19.8 19.8">
            <rect x="0.4" y="0.4" fill="#d9a32b" stroke="#000000" strokeWidth="0.5" strokeMiterlimit="10" width="19" height="19"/>
            </svg>
            <span>- Indigenous protected areas</span>
          </div>
          <div>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19.8 19.8" enableBackground="new 0 0 19.8 19.8">
            <rect x="0.4" y="0.4" fill="#166491" stroke="#000000" strokeWidth="0.5" strokeMiterlimit="10" width="19" height="19"/>
            </svg>
            <span>- NT parks</span>
          </div>
          <div>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19.8 19.8" enableBackground="new 0 0 19.8 19.8">
            <rect x="0.4" y="0.4" fill="#81499b" stroke="#000000" strokeWidth="0.5" strokeMiterlimit="10" width="19" height="19"/>
            </svg>
            <span>- Ulu<u>r</u>u-Kata Tju<u>t</u>a National Park</span>
          </div>
        </div>
      );
    } else {
      setInfoContent("");
    }
  }

  return (
    <>
      <nav>
        {Object.keys(layers).map((l) => {
          if (layers[l].type.includes("filter")) {
            return (
              <button
                key={layers[l].id}
                className="form-checkbox has-background has-text-color"
                onClick={() => {
                  
                  const visible = layers[l].visible;
                  for (const lay in layers) {
                    if (
                      layers[lay].hasOwnProperty("markers") &&
                      layers[lay].markers.hasOwnProperty("marker")
                    ) {
                      layers[lay].markers.marker.setMap(null);
                      delete layers[lay].markers.marker;
                    }

                    if (!layers[lay].group.includes("g0")) {
                      if (layers[lay].group === layers[l].group) {
                        if (layers[lay].type.includes("spatial")) {
                          if (layers[lay]?.layer?.getMap() && visible) {
                            layers[lay].layer.setMap(null);
                          } else {
                            layers[lay].layer.setMap(map);
                          }
                        }

                        if (layers[lay].hasOwnProperty("markers")) {
                          for (const c in layers[lay].markers) {
                            if (
                              layers[lay]?.markers[c].marker &&
                              layers[lay].markers[c]?.window
                            ) {
                              layers[lay].markers[c].window.close();
                              layers[lay].markers[c].marker.setMap(null);
                            }
                          }
                        }

                        if (
                          layers[lay].type.includes("marker") ||
                          layers[lay].type.includes("label")
                        ) {
                          for (const d in layers[lay].data) {
                            if (layers[lay].data[d]?.marker) {
                              if (layers[lay].data[d]?.marker?.getMap()) {
                                if (visible) {
                                  if (layers[lay].data[d]?.window) {
                                    layers[lay].data[d].window.close();
                                  }
                                  layers[lay].data[d].marker.setMap(null);
                                }
                              } else {
                                layers[lay].data[d].marker.setMap(map);
                              }
                            }
                          }

                          if (layers[lay]?.windows) {
                            layers[lay].windows.close();
                            delete layers[lay].windows;
                          }
                        }

                        layers[lay].visible = visible ? false : true;
                      } else {
                        if (layers[lay].type.includes("spatial")) {
                          if (layers[lay]?.layer?.getMap()) {
                            layers[lay].layer.setMap(null);
                          }
                        }

                        if (layers[lay].hasOwnProperty("markers")) {
                          for (const c in layers[lay].markers) {
                            if (
                              layers[lay]?.markers[c].marker &&
                              layers[lay].markers[c]?.window
                            ) {
                              layers[lay].markers[c].window.close();
                              layers[lay].markers[c].marker.setMap(null);
                            }
                          }
                        }

                        if (
                          layers[lay].type.includes("marker") ||
                          layers[lay].type.includes("label")
                        ) {
                          for (const d in layers[lay].data) {
                            if (layers[lay].data[d]?.marker) {
                              if (layers[lay].data[d]?.marker?.getMap()) {
                                if (layers[lay].data[d]?.window) {
                                  layers[lay].data[d].window.close();
                                }
                                layers[lay].data[d].marker.setMap(null);
                              }
                            }
                          }
                          if (layers[lay]?.windows) {
                            layers[lay].windows.close();
                            delete layers[lay].windows;
                          }
                        }

                        layers[lay].visible = false;
                      }
                    }
                  }

                  layers[l].visible = visible ? false : true;

                  visible ? setInfoContent('') : handleInfoContent(layers[l]);

                  setLayers({...layers });
                  
                }}
              >
                <span data-visible={layers[l].visible}>{layers[l].title}</span>
              </button>
            );
          }
          return null;
        })}
      </nav>
      <footer>
        <h3>Information</h3>
        <div>
          <div>
            <svg version="1.1" x="0px" y="0px" viewBox="0 0 19.8 19.8">
              <polygon
                fill="#d5aa9b"
                points="11.4,14.3 11.4,5.6 11.4,2.7 0.7,2.7 0.7,5.6 8.3,5.6 8.3,14.3 8.3,17.1 11.4,17.1 18.9,17.1 
        18.9,14.3 "
              />
            </svg>
            <span>- Region borders</span>
          </div>
          <div>
            <svg version="1.1" x="0px" y="0px" viewBox="0 0 19.8 19.8">
              <path
                fill="#272a59"
                stroke="#272a59"
                strokeWidth="1"
                opacity="0.3"
                d="M11.3,7c0.4-0.8,0.8-1.6,1-2.3c0.2-0.7,0.5-1.4,0.8-2h-0.5c-0.2,0.5-0.4,1-0.5,1.5c-0.1,0.4-0.3,0.8-0.5,1.2
        c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.4-0.3,0.7c-0.6,1.2-1.1,2.3-1.2,3.6c-0.1,1.7-1.3,3.1-2.9,3.3c-1.3,0.2-2.1,0.8-2.9,1.7
        c-0.5,0.6-1.2,0.9-1.8,1.2L2,16.5v0.8c0.5-0.4,1-0.9,1.5-1.4l0.2-0.2c0.8-0.8,1.7-1.6,3-1.6c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0
        c0.5,0,0.6-0.2,0.6-0.4c0.5-1.5,1.8-1.5,2.5-1.5l0.3,0c0.8,0,1.5,0,2.3,0c0.9,0,1.8,0,2.7,0l0.2,0c0.4,0,0.8,0,1.1-0.1
        c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.3,0-0.5c0-0.2-0.1-0.2-0.1-0.2c-0.1,0-0.2,0-0.3,0c-0.7,0.2-1.4,0.3-2.4,0.3
        c-0.4,0-0.8,0-1.2,0c-0.4,0-0.8,0-1.2,0l-0.1,0c-0.9,0-1.6-0.1-2-0.6C10,10.6,10.1,9.9,10.4,9C10.7,8.3,11,7.6,11.3,7z"
              />
            </svg>
            <span>- Roads</span>
          </div>
        </div>
        {infoContent}
      </footer>
    </>
  );
}
